export const completionEstimateExplanation = "Model-based estimate from comparable permits; it is not guaranteed.";
